/**
 * sod-catalogo-ricerca API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ServizioCatalogoSacchettoFindRequest } from '../model/servizioCatalogoSacchettoFindRequest';
// @ts-ignore
import { ServizioCatalogoSacchettoRicercaResponse } from '../model/servizioCatalogoSacchettoRicercaResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class RicercaCatalogoSacchettoResourceService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * List Catalogo Sacchetto
     * @endpoint post /catalogo/list/catalogo-sacchetto
     * @param servizioCatalogoSacchettoFindRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public catalogoListCatalogoSacchettoPost(servizioCatalogoSacchettoFindRequest: ServizioCatalogoSacchettoFindRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioCatalogoSacchettoRicercaResponse>;
    public catalogoListCatalogoSacchettoPost(servizioCatalogoSacchettoFindRequest: ServizioCatalogoSacchettoFindRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioCatalogoSacchettoRicercaResponse>>;
    public catalogoListCatalogoSacchettoPost(servizioCatalogoSacchettoFindRequest: ServizioCatalogoSacchettoFindRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioCatalogoSacchettoRicercaResponse>>;
    public catalogoListCatalogoSacchettoPost(servizioCatalogoSacchettoFindRequest: ServizioCatalogoSacchettoFindRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (servizioCatalogoSacchettoFindRequest === null || servizioCatalogoSacchettoFindRequest === undefined) {
            throw new Error('Required parameter servizioCatalogoSacchettoFindRequest was null or undefined when calling catalogoListCatalogoSacchettoPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/catalogo/list/catalogo-sacchetto`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioCatalogoSacchettoRicercaResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioCatalogoSacchettoFindRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
